import { render } from "./SchemeErdCard.vue?vue&type=template&id=db3cae4c"
import script from "./SchemeErdCard.vue?vue&type=script&lang=js"
export * from "./SchemeErdCard.vue?vue&type=script&lang=js"

import "./SchemeErdCard.vue?vue&type=style&index=0&id=db3cae4c&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/widgets/components_core/graph/SchemeErdCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "db3cae4c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('db3cae4c', __exports__)) {
    api.reload('db3cae4c', __exports__)
  }
  
  module.hot.accept("./SchemeErdCard.vue?vue&type=template&id=db3cae4c", () => {
    api.rerender('db3cae4c', render)
  })

}


export default __exports__